"use strict";

const $ = window.jQuery || {};
const Handlebars = window.Handlebars || {};
const Helpers = new(require('./helpers.js'));
const Validate = new (require('./validate.js'));
const MelissaExpressAddress = require('./melissa-express-address.js');

module.exports = class {
    $html;
    $body;
    $module;
    $searchFormScreen;
    $searchForm;
    $zipCodeInput;
    $searchCountyFormScreen;
    $searchCountyForm;
    $countySelect;
    $searchCountyBackButton;
    $resultsScreen;
    $resultsScreenContent;
    $resultsBackButton;
    $resultsTable;
    $resultsTableHeaders;
    $resultsTableColumns;
    $noResultsScreen;
    $noResultsScreenContent;
    $noResultsBackButton;
    $registrationFormScreen;
    $registrationForm;
    $registrationFormSubmitButton;
    $registrationBackButton;
    $registrationFirstNameField;
    $registrationLastNameField;
    $registrationStreetAddressField;
    $registrationCityField;
    $registrationCountyField;
    $registrationStateField;
    $registrationZipCodeField;
    $registrationEmailField;
    $registrationPhoneNumberField;
    $registrationMobilePhoneNumberField;
    $registrationMelissaResultCodeField;

    #moduleIndex;
    #moduleElement;
    #dataTable;
    #cache = { user: {}, results: {} };
	#params;
    #initialized = false;
    #selectedResultData = {};
    #melissaExpressAddress;

    #validationMessages = {
        zip_code: 'Please enter your 5-digit zip code.',
        phone_number: 'Please enter your ten-digit phone number with area code (no dashes or other special characters).'
    };

    #eventNamespace = 'lumeris-salesforce-events';

    selectors = {
        searchFormScreen: '.search-form-screen',
        searchCountyFormScreen: '.search-county-form-screen',
        resultsScreen: '.results-screen',
        noResultsScreen: '.no-results-screen',
        registrationFormScreen: '.registration-form-screen'
    };

	templates = {
        search: {
            screen: '',
        },
        searchCounty: {
            screen: '',
        },
        results: {
            screen: '',
            tableColumns: [],
        },
        noResults: {
            screen: '',
        },
        registration: {
            screen: ''
        }
    };

    columnsConfig = [];

    gfid = 0;
    market = '';
    eventTypes = [];
    meetingTypes = [];
    zc2marketMap = {};
    campaignId = '';
    redirectURL = '';

	constructor(moduleIndex, moduleElement) {
		if (typeof moduleIndex === 'undefined' || typeof moduleElement === 'undefined') {
			return null;
		}

		this.#moduleIndex = moduleIndex;
        this.#moduleElement = moduleElement;
        this.$module = $(moduleElement);

        this.#params = new URLSearchParams(window.location.search);

        if (this.isCustomModule() || !this.isBootstrap()) {
            this.$module.trigger(this.getEventName('init-module'), {
                Handlebars: Handlebars,
                params: this.#params,
                moduleIndex: moduleIndex, 
                moduleElement: moduleElement
            });
            
            return null;
        }

        this.$html = $('html');
        this.$body = $('body');
        this.$body.attr('data-lum-sf-events-active-market', '');

        this.$searchFormScreen = this.$module.find(this.selectors.searchFormScreen);
        this.$searchCountyFormScreen = this.$module.find(this.selectors.searchCountyFormScreen);
        this.$resultsScreen = this.$module.find(this.selectors.resultsScreen);
        this.$noResultsScreen = this.$module.find(this.selectors.noResultsScreen);
        this.$registrationFormScreen = this.$module.find(this.selectors.registrationFormScreen);

        this.gfid = this.setModuleData('gfid', 'number');
        this.market = this.setModuleData('market', 'string');
        this.eventTypes = this.setModuleData('event-types', 'array');
        this.meetingTypes = this.setModuleData('meeting-types', 'array');
        this.zc2marketMap = this.setModuleData('zc2market-map', 'json');
        this.campaignId = this.setModuleData('campaign-id', 'string');

        this.redirectURL = Helpers.normalizeRedirectURL(this.setModuleData('redirect-url'));

        this.#cache.user = this.#params;

        this.bind();

        this.initTemplates();
        this.initSearchFormScreen();

        this.$module.addClass('loaded is-search-form');
		this.#initialized = true;
	}

	bind() {
        $(window).on('resize', (event) => { return this.onWindowResize(event); });
	}

	get $module() {
		return this.$module;
	}

    get dataTable() {
        return this.#dataTable;
    }

    get cache() {
        return this.#cache;
    }

    get initialized() {
		return this.#initialized;
	}

    get eventNameSpace() {
        return this.#eventNamespace;
    }

    get params() {
        return this.#params;
    }

    get campaignId() {
        return this.campaignId;
    }

    get gfid() {
        return this.gfid;
    }

    get gclid() {
        return this.#params.get('gclid');
    }

    get redirectURL() {
        return this.redirectURL;
    }

    get market() {
        return this.market;
    }

    get eventTypes() {
        return this.eventTypes;
    }

    get meetingTypes() {
        return this.meetingTypes;
    }

    get zc2marketMap() {
        return this.zc2marketMap;
    }

    get zc2market() {
        return this.selectedMarket;
    }

    get selectedMarket() {
        return (this.$countySelect) ? this.$countySelect.val() : this.getMarketByZipCode((this.$zipCodeInput.val() ?? '').trim() ?? null);
    }

    get selectedCounty() {
        return (this.$countySelect) ? this.$countySelect.children(':selected').text() : null;
    }

    get paramsData() {
        const data = {};

        for (let [key, value] of this.params.entries()) {
            data[key] = value;
        }

        return data;
    }

    get searchData() {
        return {
            zip_code: this.$zipCodeInput.val() 
        };
    }

    get registrationFormData() {
        const data = {
            first_name: '',
            last_name: '',
            street_address: '',
            city: '',
            county: '',
            state: '',
            zip_code: '',
            email_address: '',
            phone_number: '',
            permission_to_call_email: '',
            permission_to_text: '',
            campaign_id: '',
            sales_event_id: '',
            melissa_result_code: '',
            gclid: '',
            json: '',
            _wpnonce: '',
            _wp_http_referer: ''
        };

        new FormData(this.$registrationForm.get(0)).forEach((val,key) => { data[key] = val; });

        return data;
    }

    get preparedRegistrationFormData() {
        const data = this.registrationFormData;

        const prepared = {
            form_id: this.gfid,
            source_url: Helpers.getSourceURL(),
            user_agent: Helpers.getUserAgent(),
            status: 'active',
            is_starred: 0,
            is_read: 1,
            input_1: data.first_name,
            input_2: data.last_name,
            input_3: data.street_address,
            input_4: data.city,
            input_105: data.county,
            input_5: data.state,
            input_6: data.zip_code,
            input_7: data.email_address,
            input_8: data.phone_number,
            input_103: data.mobile_phone_number,
            input_101_1: data.permission_to_call_email,
            input_102_1: data.permission_to_text,
            input_9: data.campaign_id,
            input_10: data.sales_event_id,
            input_100: data.json,
            input_104: data.melissa_result_code,
            input_106: this.gclid,
            _wpnonce: data._wpnonce,
            _wp_http_referer: data._wp_http_referer,
            redirect_url: (data.json !== '') ? JSON.parse(data.json).redirect_url : location.href
        };

        return prepared;
    }

    get selectedResultData() {
        const data = this.#selectedResultData ?? {};
        const template = Handlebars.compile(this.redirectURL);

        let redirectURL = template(data);
        redirectURL = new URL(redirectURL);
        redirectURL.searchParams.append('seid', data.sales_event_id);

        return { ...data,
          redirect_url: redirectURL.href,
          campaign_id: this.campaignId
        };
    }

    get userData() {
        return this.cache.user ?? {};
    }

    get moduleData() {
        return {
            gfid: this.gfid,
            market: this.market,
            event_types: this.eventTypes,
            meeting_types: this.meetingTypes,
            redirect_url: this.redirectURL
        };
    }

    get melissaExpressAddress() {
        return this.#melissaExpressAddress;
    }

    get resultsPageData() {
        const data = this.#dataTable.page.info();
        data.resultsWord = (data.recordsTotal == 1) ? 'Result' : 'Results';
        data.resultsLabel = `${data.recordsTotal} ${data.resultsWord}`;

        return data;
    }

    set dataTable(val) {
        this.#dataTable = val;
    }

    set selectedResultData(data={}) {
        this.#selectedResultData = data;
    }

    set melissaExpressAddress(val) {
        this.#melissaExpressAddress = val;
    }

    cacheUserData(data={}) {
        this.cache.user = {
            first_name: (typeof data.first_name == 'undefined') ? '' : data.first_name,
            last_name: (typeof data.last_name == 'undefined') ? '' : data.last_name,
            email_address: (typeof data.email_address == 'undefined') ? '' : data.email_address,
            phone_number: (typeof data.phone_number == 'undefined') ? '' : data.phone_number,
            mobile_phone_number: (typeof data.mobile_phone_number == 'undefined') ? '' : data.mobile_phone_number,
            street_address: (typeof data.street_address == 'undefined') ? '' : data.street_address,
            city: (typeof data.city == 'undefined') ? '' : data.city,
            state: (typeof data.state == 'undefined') ? '' : data.state,
            zip_code: (typeof data.zip_code == 'undefined') ? '' : data.zip_code,
            county: (typeof data.zip_code == 'undefined') ? '' : data.county,
            permission_to_call_email: (typeof data.permission_to_call_email == 'undefined') ? '' : data.permission_to_call_email,
            permission_to_text: (typeof data.permission_to_text == 'undefined') ? '' : data.permission_to_text
        };
    }

    cacheResults(key='', data={}) {
        this.cache.results[key] = data;
    }

    

    initTemplates() {
        this.templates.search.screen = this.$searchFormScreen.get(0).outerHTML;
        this.removeSearchScreen();

        this.templates.searchCounty.screen = this.$searchCountyFormScreen.get(0).outerHTML;
        this.removeSearchCountyScreen();

        this.templates.results.screen = this.$resultsScreen.get(0).outerHTML;
        this.removeResultsScreen();

        this.templates.noResults.screen = this.$noResultsScreen.get(0).outerHTML;
        this.removeNoResultsScreen();

        this.templates.registration.screen = this.$registrationFormScreen.get(0).outerHTML;
        this.removeRegistrationFormScreen();
    }

    initSearchFormScreen() {
        this.$body.attr('data-lum-sf-events-active-market', '');

        const template = Handlebars.compile(this.templates.search.screen);

        this.$searchFormScreen = $(template(this.paramsData));
        this.$searchForm = this.$searchFormScreen.find('form');
        this.$zipCodeInput = this.$searchForm.find('.zip_code');

        this.$zipCodeInput.off();
        this.$zipCodeInput.on('keyup change input paste', (event) => { return this.onSearchInputChange(event); });
        this.$zipCodeInput.on('invalid', (event) => { return this.onSearchInputInvalid(event); });

        this.$searchForm.off().on('submit', (event) => { return this.onSearchFormSubmit(event); });

        this.$module.append(this.$searchFormScreen);

        if (this.$zipCodeInput.val() && this.params.get('auto') && ['', 'true', '1', true, 1].indexOf(this.params.get('auto'))) {
            this.$searchForm.trigger('submit');
        }
    }


    initSearchCountyFormScreen() {
        const template = Handlebars.compile(this.templates.searchCounty.screen);
        const searchedZipCode = this.$zipCodeInput.val().trim();
        const zc2market = this.getMarketByZipCode(searchedZipCode);

        this.$searchCountyFormScreen = $(template(this.paramsData));
        this.$searchCountyForm = this.$searchCountyFormScreen.find('form');
        this.$countySelect = this.$searchCountyForm.find('.county');
        this.$searchCountyBackButton = this.$searchCountyFormScreen.find('.back-button');

        for (let county in zc2market) {
            this.$countySelect.append('<option value="' + zc2market[county] + '">' + county + '</option>');
        }

        this.$searchCountyBackButton.off().on('click', (event) => { return this.onSearchCountyBackButtonClick(event); });
        this.$searchCountyForm.off().on('submit', (event) => { return this.onSearchCountyFormSubmit(event); });

        this.$module.append(this.$searchCountyFormScreen);

        for (let county in zc2market) {
            if (!zc2market[county] || zc2market[county] == 'false') {
                continue;
            }

            this.prefetchResults({zip_code: searchedZipCode, zc2market: zc2market[county]});
        }
    }

    async initResultsScreen() {
        const results = await this.getResults({ 
            zip_code: this.$zipCodeInput.val().trim(), 
            market: this.market,
            event_types: this.eventTypes,
            meeting_types: this.meetingTypes,
            zc2market: this.selectedMarket
        });

        const template = Handlebars.compile(this.templates.results.screen);
        
        this.$resultsScreen = $(template({...this.paramsData, ...this.searchData, results_count: results.length}));
        this.$resultsTable = $(this.templates.results.screen).find('table.results-table');
        this.$resultsTableHeaders = this.$resultsTable.find('thead tr').children();
        this.$resultsTableColumns = this.$resultsTable.find('tbody tr').eq(0).children();

        this.$resultsScreen.find('table.results-table').before(this.$resultsTable).remove();

        if (this.templates.results.tableColumns.length == 0) {
            this.$resultsTableColumns.each((i, col) => {
                this.templates.results.tableColumns.push({
                    html: this.$resultsTableColumns.eq(i).html(),
                    prop: this.$resultsTableColumns.eq(i).attr('data-prop'),
                    class: this.$resultsTableColumns.eq(i).attr('class'),
                    style: this.$resultsTableColumns.eq(i).attr('style'),
                    orderProp: this.$resultsTableColumns.eq(i).attr('data-order-prop')
                });
                this.$resultsTableColumns.eq(i).html('');
            });
        }

        this.$resultsTableColumns = this.$resultsTable.find('tbody').html('');

        this.$resultsBackLink = this.$resultsScreen.find('a.change-zip-code');
        this.$resultsBackLink.off().on('click', (event) => { this.onResultsBackLinkClick(event); });

        this.$resultsTypeFilterSelect = this.$resultsScreen.find('select.type-filter');
        this.$resultsTypeFilterSelect.off().on('change', (event) => { this.onResultsTypeFilterSelectChange(event); });

        await this.initDataTable();

        this.$module.append(this.$resultsScreen);
        this.$body.attr('data-lum-sf-events-active-market', this.selectedMarket);
    }

    async initDataTable() {
        this.columnsConfig.length = 0;

        const columnDefs = [];
        const isOrderable = [];
        const notOrderable = [];
        const isSearchable = [];
        const notSearchable = [];

        const moduleData = this.moduleData;
        const searchData = this.searchData;

        this.$resultsTableHeaders.each((i, el) => {
            const prop = this.templates.results.tableColumns[i].prop;
            const orderProp = (this.templates.results.tableColumns[i].orderProp) ? this.templates.results.tableColumns[i].orderProp : null;
            const defaultContent = (prop) ? '' : this.templates.results.tableColumns[i].html;
            const orderable = (prop) ? true : false;
            const searchable = (prop) ? true : false;

            if (orderable) {
                isOrderable.push(i);
            } else {
                notOrderable.push(i);
            }

            if (searchable) {
                isSearchable.push(i);
            } else {
                notSearchable.push(i);
            }

            const colConfig = {
                data: prop, 
                defaultContent: defaultContent,
                className: this.templates.results.tableColumns[i].class,
                orderable: orderable,
                searchable: searchable
            };

            if ((prop === 'timestamp' || prop === 'datetime') && orderable) {
                colConfig.render = {
                    display: (data) => {
                        return Helpers.transformToFormattedDateTimeString(data);
                    },
                    sort: (data) => {
                        return data;
                    }
                };
            } else if (prop === 'time' && orderable) {
                colConfig.render = (data, type, rowData) => {
                    if (type === 'display' || type === 'filter') {
                        return data;
                    }
                    return rowData.time_sort;
                };
            } else if (prop === 'distance') {
                colConfig.render = {
                    display: (data) => {
                        return (data) ? `${data}\u00A0mi.` : data;
                    },
                    sort: (data) => {
                        return (typeof data == 'undefined') ? 0 : Number(data) + 1;
                    }
                };

                columnDefs.push({ type: 'num', targets: i});

            } else if (prop === 'zip_code') {
                colConfig.render = {
                    display: (data) => {
                        return (data) ? data : defaultContent;
                    },
                    sort: (data) => {
                        return data;
                    }
                };
            } else if (prop === 'location_display') {
                colConfig.render = (data, type, rowData, meta) => {
                    return (rowData.environment === 'Virtual') ? `<strong>${data}</strong>` : `<a class="map-url" href="${rowData.map_url}" target="_blank" title="View on map">${data}</a>`;
                };
            } else if (prop && orderProp) {
                colConfig.render = (data, type, rowData) => {
                    if (type === 'display' || type === 'filter') {
                        return data;
                    }
                    return (typeof rowData[orderProp] !== 'undefined') ? rowData[orderProp] : defaultContent;
                };
            } else {
                colConfig.render = (data, type, rowData, meta) => {
                    if (data) {
                        return data;
                    }

                    const content = this.columnsConfig[meta.col].defaultContent;
                    const template = Handlebars.compile(content);
                    const templateData = {
                        module: moduleData,
                        search: searchData,
                        event: this.getEventData(rowData)
                    };

                    return template(templateData);
                };
            }

            this.columnsConfig.push(colConfig);
        });
        
        columnDefs.push({ targets: isOrderable, orderable: true });
        columnDefs.push({ targets: notOrderable, orderable: false });
        columnDefs.push({ targets: isSearchable, searchable: true });
        columnDefs.push({ targets: notSearchable, searchable: false });

        const results = await this.getResults({ 
            zip_code: this.$zipCodeInput.val().trim(), 
            market: this.market,
            event_types: this.eventTypes,
            meeting_types: this.meetingTypes,
            zc2market: this.selectedMarket
        });

        this.dataTable = this.$resultsTable.DataTable({
            autoWidth: false,
            data: results,
            columns: this.columnsConfig,
            columnDefs: columnDefs,
            fixedHeader: false,
            lengthChange: false,
            order: [0, 'asc'],
            orderMulti: false,
            pageLength: 25,
            scrollX: false,
            searching: false,
            info: false,
            rowCallback: (row, data, displayNum, displayIndex, dataIndex) => {
                return this.onDataTableRowCallback(row, data, displayNum, displayIndex, dataIndex);
            } 
        });

        this.dataTable.on('order.dt', (event, settings, ordArr) => { return this.onDataTableSort(event, settings, ordArr); });
    }

    initNoResultsScreen() {
        const template = Handlebars.compile(this.templates.noResults.screen);

        this.$noResultsScreen = $(template({...this.paramsData, ...this.searchData}));
        this.$noResultsScreenContent = this.$noResultsScreen.find('no-results-screen-content');

        // this.$noResultsScreenContent.html(this.$noResultsScreen.find('no-results-screen-content').html());
        this.$noResultsBackButton = this.$noResultsScreen.find('.back-button');
        this.$noResultsBackButton.off().on('click', (event) => { return this.onNoResultsBackButtonClick(event); });

        this.$module.append(this.$noResultsScreen);

        this.$body.attr('data-lum-sf-events-active-market', this.selectedMarket);
    }

    initRegistrationFormScreen() {
        const template = Handlebars.compile(this.templates.registration.screen);
        const data = {
            module: this.moduleData,
            user: this.userData,
            selected: this.selectedResultData 
        };

        this.$registrationFormScreen = $(template(data));
        this.$registrationForm = this.$registrationFormScreen.find('form');
        this.$registrationFormSubmitButton = this.$registrationForm.find('button[type="submit"]');
        this.$registrationBackButton = this.$registrationFormScreen.find('.back-button');

        const formId = this.$registrationForm.attr('id');

        this.$registrationFirstNameField = this.$registrationForm.find('input.first_name');
        this.$registrationLastNameField = this.$registrationForm.find('input.last_name');
        this.$registrationStreetAddressField = this.$registrationForm.find('input.street_address');
        this.$registrationCityField = this.$registrationForm.find('input.city');
        this.$registrationCountyField = this.$registrationForm.find('input.county');
        this.$registrationStateField = this.$registrationForm.find('select.state');
        this.$registrationZipCodeField = this.$registrationForm.find('input.zip_code');
        this.$registrationMelissaResultCodeField = this.$registrationForm.find('input.melissa_result_code');
        this.$registrationEmailField = this.$registrationForm.find('input.email_address');
        this.$registrationPhoneNumberField = this.$registrationForm.find('input.phone_number');
        this.$registrationMobilePhoneNumberField = this.$registrationForm.find('input.mobile_phone_number');

        
        this.$registrationBackButton.off().on('click', (event) => { this.onRegistrationBackButtonClick(event); });

        this.$registrationForm.off()
            .on('submit', (event) => { this.onRegistrationFormSubmit(event); })
            .on(`melissa-express-address:insert-dropdown:${formId}`, (event, data) => { this.onMelissaInsertDropdown(event, data); })
            .on(`melissa-express-address:updated-results:${formId}`, (event, data) => { this.onMelissaUpdatedResults(event, data); })
            .on(`melissa-express-address:selected-address:${formId}`, (event, data) => { this.onMelissaSelectedAddress(event, data); })
            .on(`melissa-express-address:result-code-error:${formId}`, (event, data) => { this.onMelissaResultCodeError(event, data); });

        this.$registrationZipCodeField.off()
            .on('keyup change input paste', (event) => { this.onRegistrationZipCodeFieldChange(event); })
            .on('invalid', (event) => { this.onRegistrationZipCodeFieldInvalid(event); });
        this.$registrationPhoneNumberField.off()
            .on('keyup change input paste', (event) => { this.onRegistrationPhoneNumberFieldChange(event); })
            .on('invalid', (event) => { this.onRegistrationPhoneNumberFieldInvalid(event); });
        this.$registrationMobilePhoneNumberField.off()
            .on('keyup change input paste', (event) => { this.onRegistrationMobilePhoneNumberFieldChange(event); })
            .on('invalid', (event) => { this.onRegistrationMobilePhoneNumberFieldInvalid(event); });
        
        this.$module.append(this.$registrationFormScreen);

        this.#melissaExpressAddress = new MelissaExpressAddress({
            id: formId,
            $form: this.$registrationForm,
            $streetAddressField: this.$registrationStreetAddressField,
            $cityField: this.$registrationCityField,
            $countyField: this.$registrationCountyField,
            $stateField: this.$registrationStateField,
            $zipCodeField: this.$registrationZipCodeField,
            $resultCodeField: this.$registrationMelissaResultCodeField
        });
    }

    getEventName(suffix) {
        return (suffix) ? this.eventNamespace + ':' + suffix : this.eventNamespace;
    }

    getResults(options) {
        const cacheKey = Helpers.generateCacheKeyFromOptions(options);
        const cachedResults = this.getCachedResults(cacheKey);

        if (cachedResults !== null && typeof cachedResults == 'object') {
            return cachedResults;
        }

        if (cachedResults == 'pending') {
            return new Promise((resolve, reject) => {
                const thisInterval = setInterval(() => {
                    const results = this.getCachedResults(cacheKey);

                    if (results !== null && typeof results == 'object') {
                        clearInterval(thisInterval);
                        resolve(results);
                    }
                }, 50);
            });
        }

        this.cacheResults(cacheKey, 'pending');

        return fetch('/wp-json/lum-sf-events/v1/events?' + Helpers.generateQueryString(options), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        }).then((response) => {
            const json = response.json();
            this.cacheResults(cacheKey, json);
            return json;
        }).catch((error) => {
            console.error(error);
            return [];
        });
    }

    getMarketByZipCode(zip_code=null) {
        if (!zip_code) {
            return null;
        }

        const map = this.zc2marketMap;

        if (map == {} || typeof map[zip_code] == 'undefined') {
            return null;
        }

        return map[zip_code];
    }

    getEventData(data={}) {
        for (let key in data) {
            if (!data[key]) {
                continue;
            }

            const template = Handlebars.compile(Helpers.parseHTML(data[key]));
            data[key] = template(data);
        }
        return data;
    }

    getCachedUserData() {
        return this.cache.user;
    }

    getCachedResults(key=null) {
        return (key == null) ? this.cache.results : this.cache.results[key] ?? null;
    }

    async getSubmittedSearchResults(options={}) {

        const zc2market = this.getMarketByZipCode(this.$zipCodeInput.val().trim());

        const defaultOptions = { 
            zip_code: this.$zipCodeInput.val().trim(), 
            market: this.market,
            event_types: this.eventTypes,
            meeting_types: this.meetingTypes,
            zc2market: (typeof zc2market == 'string') ? zc2market : false
        };

        const results = await this.getResults({...defaultOptions, ...options});

        if (results.length == 0) {
            this.noResults();
            return null;
        }

        if (!this.dataTable) {
            this.initResultsScreen();
        } else {
            this.updateResults(options);
        }
        this.showResultsScreen();
        
        return null;
    }

    getDropdownContent(row, data) {
        const $row = $(`<tr id="seid-${data.sales_event_id}" class="dropdown-row">`);
        const $registerButton = $(row).find('button.register-button');
        const description = `<div class="description">${Helpers.text2p(data.description)}</div>`;

        const eventNameAndFullAddress = `<p><strong>${data.name}</strong><br>${data.location_display}<br>${data.street_address}<br>${data.city},\u00A0${data.state}\u00A0${data.zip_code} <a href="${data.map_url}" target="_blank" title="Show Map" ref="nofollow">[show map]</a></p>`;
        const content = (data.environment === 'Virtual') ? description : `${eventNameAndFullAddress}${description}`;
        
        const $col1 = $('<td>').append($registerButton.clone().addClass('d-xl-none'));
        const $col2 = $(`<td colspan="3">`).append(content);
        const $col3 = $('<td colspan="2" class="d-none d-xl-table-cell">');

        if (this.$html.hasClass('min-xl')) {
            $col2.attr('colspan', 4);
        }

        $(window).on('resize', (event) => {
            let colspan = 3;

            if (this.$html.hasClass('min-xl')) {
                colspan = 4;
            }

            $col2.attr('colspan', colspan);
        });
        
        $row.append($col1).append($col2).append($col3);
        return $row;
    }

    setModuleData(key, type='string') {
        const attr = 'data-' + key;
        const val = this.$module.attr(attr);
        this.$module.removeAttr(attr);

        if (type == 'string') {
            return val;
        }

        if (type == 'number') {
            return Number(val);
        }

        if (type == 'array') {
            return val.split(',').map((option) => {
                return option.trim();
            });
        }

        if (type == 'json') {
            try {
                return JSON.parse(val);
            } catch (error) {
                return JSON.parse('{}');
            }
        }
    }

    deleteCachedResults(key=null) {
        if (key === null) {
            this.cache.results = {};
        } else {
            delete this.cache.results[key];
        }
    }

    clearDropdowns() {
        if (!this.$resultsTable) {
            return null;
        }

        this.$resultsTable.find('tr.dropdown-row').css('display', 'none');
        this.$resultsTable.find('button.dropdown-row-toggle').attr('aria-expanded', 'false');
        this.$resultsTable.find('button.dropdown-row-toggle .mdi.mdi-chevron-down').addClass('mdi-chevron-up').removeClass('mdi-chevron-down');
    }

    clearSelectedResultData() {
        this.selectedResultData = {};
    }

    clearResults() {
        if (this.dataTable) {
            this.dataTable.clear().draw();
        }
    }


    async updateResults(options={}) {
        if (!options || !(options instanceof Object)) {
            return null;
        }
        
        this.clearResults();

        const zc2market = this.getMarketByZipCode(this.$zipCodeInput.val().trim());

        const defaultOptions = { 
            zip_code: this.$zipCodeInput.val().trim(), 
            market: this.market,
            event_types: this.eventTypes,
            meeting_types: this.meetingTypes,
            zc2market: (typeof zc2market == 'string') ? zc2market : null
        };
        
        const results = await this.getResults({...defaultOptions, ...options});

        if (results.length == 0) {
            this.noResults();
            return null;
        }

        this.dataTable.rows.add(results).draw();
    }

    isBootstrap() {
        return (this.$module.hasClass('bootstrap')) ? true : false;
    }

    isCustomModule() {
        return (this.$module.hasClass('custom')) ? true : false;
    }

    isGravityForm() {
        return (this.gfid == 0) ? false : true;
    }

    enableRegistrationFormSubmitButton() {
        this.$registrationFormSubmitButton.removeAttr('disabled');
    }

    disableRegistrationFormSubmitButton() {
        this.$registrationFormSubmitButton.attr('disabled');
    }

    showSearchFormScreen() {
        this.$module.addClass('is-search-form').removeClass('is-search-county-form is-results is-no-results is-registration');
        this.scrollToModuleTop();
        this.$zipCodeInput.focus();

        requestAnimationFrame(() => {
            this.$html.trigger('lumeris-salesforce-member-meetings:show-search-form');
        });
    }

    showSearchCountyFormScreen() {
        this.$module.addClass('is-search-county-form').removeClass('is-search-form is-results is-no-results is-registration');
        this.scrollToModuleTop();

        requestAnimationFrame(() => {
            this.$html.trigger('lumeris-salesforce-member-meetings:show-county-form');
        });
    }

    showResultsScreen() {
        this.$module.addClass('is-results').removeClass('is-search-form is-search-county-form is-no-results is-registration');
        this.scrollToModuleTop();
        
        requestAnimationFrame(() => {
            this.$html.trigger('lumeris-salesforce-member-meetings:show-results');
        });
    }

    showNoResultsScreen() {
        this.$module.addClass('is-no-results').removeClass('is-search-form is-search-county-form is-results is-registration');
        this.scrollToModuleTop();

        requestAnimationFrame(() => {
            this.$html.trigger('lumeris-salesforce-member-meetings:show-no-results');
        });
    }

    showRegistrationFormScreen() {
        this.$module.addClass('is-registration').removeClass('is-search-form is-search-county-form is-results');
        this.scrollToModuleTop();

        requestAnimationFrame(() => {
            this.$html.trigger('lumeris-salesforce-member-meetings:show-registration-form');
        });
    }

    showLoadingAnimation() {
        this.$module.addClass('is-loading');
    }

    hideLoadingAnimation() {
        this.$module.removeClass('is-loading');
    }

    removeSearchScreen() {
        this.$module.find(this.selectors.searchFormScreen).remove();
    }

    removeSearchCountyScreen() {
        this.$module.find(this.selectors.searchCountyFormScreen).remove();
    }

    removeResultsScreen() {
        this.$module.find(this.selectors.resultsScreen).remove();
    }

    removeNoResultsScreen() {
        this.$module.find(this.selectors.noResultsScreen).remove();
    }

    removeRegistrationFormScreen() {
        this.$module.find(this.selectors.registrationFormScreen).remove();
    }

    removeDataTable() {
        this.dataTable = null;
    }

    resetSearch() {
        this.$body.attr('data-lum-sf-events-active-market', '');
        this.$zipCodeInput.val('');

        if (this.$searchCountyFormScreen) {
            this.$searchCountyFormScreen.remove();
            this.$searchCountyFormScreen = null;
            this.$searchCountyForm = null;
            this.$countySelect = null;
            this.$searchCountyBackButton = null;
        }
    }

    noResults() {
        this.clearResults();

        this.initNoResultsScreen();
        this.showNoResultsScreen();

        this.$body.attr('data-lum-sf-events-active-market', this.selectedMarket);
    }

    storeRegistrationFormData() {
        const searchData = {
            county: this.selectedCounty,
            market: this.selectedMarket
        };

        const userData = {...searchData, ...this.registrationFormData};

        this.cacheUserData(userData);
        return userData;
    }

    async prefetchResults(options={}) {
        if (!options || !(options instanceof Object)) {
            return null;
        }

        const zc2market = this.getMarketByZipCode(this.$zipCodeInput.val().trim());

        const defaultOptions = { 
            zip_code: this.$zipCodeInput.val().trim(), 
            market: this.market,
            event_types: this.eventTypes,
            meeting_types: this.meetingTypes,
            zc2market: (typeof zc2market == 'string') ? zc2market : false
        };

        const mergedOptions = {...defaultOptions, ...options};

        const cacheKey = Helpers.generateCacheKeyFromOptions(mergedOptions);
        
        const results = await this.getResults(mergedOptions);
        
        if (results.length === 0) {
            return null;
        }

        const keys = Object.keys(this.getCachedResults());

        if (keys.length > 5) {
            this.deleteCachedResults(keys[0]);
        }

        this.cacheResults(cacheKey, results);
    }

    postRegistrationFormData() {
        const data = this.registrationFormData;
        const preparedData = this.preparedRegistrationFormData;
        const moduleData = this.moduleData;
        
        if (!this.isGravityForm()) {
            this.$module.trigger(this.getEventName('post-registration'), {data: data, preparedData: preparedData, moduleData: moduleData});
            return null;
        }
        
        return fetch('/wp-json/lum-sf-events/v1/gf/submit-form', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            cache: 'no-cache',
            body: JSON.stringify(preparedData)
        }).then((response) => {
            response.json().then((json) => {
                if (typeof json.error !== 'undefined') {
                    console.error(json.error);
                    alert('There was an error while registering. Please refresh your browser and try again.');
                    this.hideLoadingAnimation();
                    this.enableRegistrationFormSubmitButton();
                    return null;
                }
                
                window.open(preparedData.redirect_url, '_self');
                this.hideLoadingAnimation();
                this.showResultsScreen();
                this.removeRegistrationFormScreen();
                return null;
            });
        }).catch((error) => {
            console.error(error);
            return null;
        });
    }

    doPreSearchActions() {
        const validatedVal = Validate.getValidatedZipCode(this.$zipCodeInput);
        this.$zipCodeInput.val(validatedVal);

        if (validatedVal.length !== 5) {
            return null;
        }

        const zc2market = this.getMarketByZipCode(validatedVal);

        if (!zc2market || typeof zc2market == 'string') {
            
            this.prefetchResults({
                zip_code: validatedVal,
                market: this.market,
                event_types: this.eventTypes,
                meeting_types: this.meetingTypes,
                zc2market: zc2market
            });
        }

        return null;
    }

    scrollToModuleTop() {
        $(window).scrollTop(this.$module.offset().top - ($(window).height()/4));
    }

    onWindowResize(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }

        this.clearDropdowns();
    }

    

    onSearchInputChange(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity('');
        this.doPreSearchActions();
    }

    onSearchInputInvalid(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity(Validate.getValidationMessage('zip_code'));
    }

    async onSearchFormSubmit(event) {
        if (!event || event.type !== 'submit' || (event.originalEvent && event.originalEvent instanceof SubmitEvent === false)) {
            return null;
        }

        event.preventDefault();

        const searchedZipCode = this.$zipCodeInput.val().trim();
        const marketFilter = this.market;
        const zc2market = this.getMarketByZipCode(searchedZipCode);

        if (zc2market !== null && typeof zc2market == 'object') {
            if (marketFilter !== '') {
                for (let county in Object.keys(zc2market)) {
                    if (this.zc2marketMap[searchedZipCode] && this.zc2marketMap[searchedZipCode][county] && this.zc2marketMap[searchedZipCode][county] == marketFilter) {
                        this.initSearchCountyFormScreen();
                        this.showSearchCountyFormScreen();
                        return null; 
                    }
                }

                this.noResults();
                return null;
            } else {
                this.initSearchCountyFormScreen();
                this.showSearchCountyFormScreen();
                return null;
            }
        } else if (marketFilter !== '' && zc2market !== marketFilter) {
            this.noResults();
            return null;
        }

        await this.getSubmittedSearchResults();

        return null;
    }

    onSearchCountyFormSubmit(event) {
        if (!event || event.type !== 'submit' || (event.originalEvent && event.originalEvent instanceof SubmitEvent === false)) {
            return null;
        }

        event.preventDefault();

        const searchedZipCode = this.$zipCodeInput.val().trim();
        const marketFilter = this.market;
        const market = this.selectedMarket;

        if (market == false || market == 'false') {
            this.noResults();
            return null;
        }

        this.getSubmittedSearchResults({zc2market: market});
        return null;
    }

    onDataTableSort(event, settings, ordArr) {
        if (!event || !settings || !ordArr) {
            return null;
        }

        this.clearDropdowns();
    }

    onDataTableRowCallback(row, data, displayNum, displayIndex, dataIndex) {
        const $row = $(row);

        $row.attr('data-index', dataIndex);
        $row.find('.register-button').off().on('click', this.onDataTableRegisterButtonClick.bind(this));
        $row.find('.map-button').off().on('click', this.onDataTableMapButtonClick.bind(this));
        
        const $dropdownContent = this.getDropdownContent(row, data);
        $dropdownContent.find('.register-button').off().on('click', this.onDataTableRegisterButtonClick.bind(this));

        const $dropdownToggle = $row.find('.dropdown-row-toggle');
        $dropdownToggle.attr('aria-controls', $dropdownContent.attr('id'));
        
        $dropdownToggle.off().on('click', (event) => {
            event.preventDefault();
            const $toggleButton = $(event.target);
            const $icon = $toggleButton.find('.mdi');

            if ($icon.hasClass('mdi-chevron-up')) {
                $toggleButton.attr('aria-expanded', 'true');
                $icon.addClass('mdi-chevron-down').removeClass('mdi-chevron-up');
                $row.after($dropdownContent);
                $dropdownContent.css('display', '');
            } else if ($icon.hasClass('mdi-chevron-down')) {
                $toggleButton.attr('aria-expanded', 'false');
                $icon.addClass('mdi-chevron-up').removeClass('mdi-chevron-down');
                $dropdownContent.css('display', 'none');
            }
        });
    } 

    onDataTableRegisterButtonClick(event) {

        console.log('onDataTableRegisterButtonClick', event);
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }

        event.preventDefault();

        const $tr = $(event.target).parents('tr');

        const rowIndex = (typeof $tr.attr('data-index') !== 'undefined') ? Number($tr.attr('data-index')) : Number($tr.prev('tr[data-index]').attr('data-index'));

        this.selectedResultData = this.dataTable.row(rowIndex).data();

        if (this.selectedResultData.meeting_link_url !== '') {
            window.open(this.selectedResultData.meeting_link_url, '_blank');
            return true;
        }

        this.initRegistrationFormScreen();
        this.showRegistrationFormScreen();
        
        return true;
    }

    onDataTableMapButtonClick(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }

        event.preventDefault();

        const rowIndex = Number($(event.target).parents('tr').attr('data-index'));

        window.open(this.dataTable.row(rowIndex).data().map_url, '_blank');
        return true;
    }

    onSearchCountyBackButtonClick(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }

        this.showSearchFormScreen();
        this.removeSearchCountyScreen();
    }

    onResultsBackLinkClick(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }

        event.preventDefault();

        this.resetSearch();

        this.showSearchFormScreen();
        this.removeSearchCountyScreen();
        this.removeResultsScreen();
        this.removeDataTable();
    }

    onNoResultsBackButtonClick(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }

        this.resetSearch();
        
        this.showSearchFormScreen();
        this.removeSearchCountyScreen();
        this.removeNoResultsScreen();
    }

    onRegistrationBackButtonClick(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        this.storeRegistrationFormData();
        this.clearSelectedResultData();
        this.showResultsScreen();
        this.removeRegistrationFormScreen();
    }

    onRegistrationFormSubmit(event) {
        if (!event || event.type !== 'submit' || (event.originalEvent && event.originalEvent instanceof SubmitEvent === false)) {
            return null;
        }
        event.preventDefault();
        this.disableRegistrationFormSubmitButton();
        this.showLoadingAnimation();
        this.postRegistrationFormData();
    }

    onRegistrationZipCodeFieldChange(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity('');
        this.$registrationZipCodeField.val(Validate.getValidatedZipCode(this.$registrationZipCodeField));
    }

    onRegistrationZipCodeFieldInvalid(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity(Validate.getValidationMessage('zip_code'));
    }

    onRegistrationPhoneNumberFieldChange(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity('');
        this.$registrationPhoneNumberField.val(Validate.getValidatedPhoneNumber(this.$registrationPhoneNumberField));
    }

    onRegistrationMobilePhoneNumberFieldChange(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity('');
        this.$registrationMobilePhoneNumberField.val(Validate.getValidatedPhoneNumber(this.$registrationMobilePhoneNumberField));
    }

    onRegistrationPhoneNumberFieldInvalid(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity(Validate.getValidationMessage('phone_number'));
    }

    onRegistrationMobilePhoneNumberFieldInvalid(event) {
        if (!event || event.originalEvent instanceof Event === false) {
            return null;
        }
        event.target.setCustomValidity(Validate.getValidationMessage('mobile_phone_number'));
    }

    onMelissaInsertDropdown(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }

        this.$registrationStreetAddressField.parent().append(data.$dropdown);
    }

    onMelissaUpdatedResults(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
    }

    onMelissaSelectedAddress(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
    }

    onMelissaResultCodeError(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
    }
	
}
